export const seriespatternRouteDef = [ 
   
    {
        path:':resource/:code/:resource/permission_set',
        component:'EditableGridWithBannerComponent',
        data : {
            selector: 'kx-editable-grid-with-banner'
        }
    }
]       

